import script from "./TopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=63341d47&lang=scss&scoped=true"

import exportComponent from "C:\\AQRepo\\customermanagedinspection_fe-brands-kra-norden\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63341d47"]])

export default __exports__